import Vue from 'vue'
import VueRouter from "vue-router"
Vue.use(VueRouter)
import App from './App.vue'
import router from './router'
import firebase from "firebase/app"
import "firebase/auth"
import "firebase/database"
import "firebase/analytics"
import vuetify from './plugins/vuetify'
import wysiwyg from "vue-wysiwyg"

Vue.config.productionTip = false

Vue.use(wysiwyg, {
  hideModules: { 
    code: true,
    image: true,
    table: true,
    separator: true,
  }
})

var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API,
  authDomain: "clients.personatalent.com",
  databaseURL: "https://persona-clients.firebaseio.com",
  projectId: "persona-clients",
  storageBucket: "persona-clients.appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
firebase.initializeApp(firebaseConfig)
firebase.analytics()

let app = null
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      vuetify,
      render: (h) => h(App)
    }).$mount("#app")
  }
})
